// extracted by mini-css-extract-plugin
module.exports = {"empty-favorites-wrapper":"FavoritesEmptyText-style_empty-favorites-wrapper__--TGk"};